import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import "./TradeRegistryPage.style.css";

const TradeRegistryPage = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  // Birden fazla tabloyu destekleyen veri yapısı
  const blocks = [
    {
      id: "trade-registry",
      title: { tr: "Ticaret Sicil", en: "Trade Registry" },
      body: {
        tr: "Cevher Jant, 2060406503 vergi kimlik numarası ile Gaziemir Vergi Dairesi’ne ve MERKEZ-104150 ticaret sicil numarası ile İzmir Ticaret Odasına bağlıdır.",
        en: "Cevher Jant is registered with Gaziemir Tax Office under tax ID 2060406503 and with the Izmir Chamber of Commerce under trade registry no. MERKEZ-104150."
      }
    },
    {
      id: "independent-auditor",
      title: { tr: "Bağımsız Denetçi", en: "Independent Auditor" },
      body: {
        tr: "KPMG Bağımsız Denetim ve Serbest Muhasebeci Mali Müşavirlik A.Ş.",
        en: "KPMG Independent Audit and Certified Public Accounting Inc."
      }
    },
    // ... gerekirse daha fazla blok ekle
  ];

  return (
    <div>
      <Meta
        title={t("trade-registry") || "Ticaret Sicil"}
        description={t("trade-registry") || "Ticaret Sicil"}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        {/* Hero (var olan görseli kullanıyoruz) */}
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("trade-registry") || "Ticaret Sicil"}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="tr-content">
            {blocks.map(b => (
              <section key={b.id} className="tr-card">
                <div className="tr-row tr-row--head">
                  <span className="tr-title">{b.title[L]}</span>
                </div>
                <div className="tr-row tr-row--body">
                  <p className="tr-text">{b.body[L]}</p>
                </div>
              </section>
            ))}
          </main>
        </div>
      </div>
    </div>
  );
};

export default TradeRegistryPage;
